import type { Editor } from "@tiptap/core";
import type { CollaborateUserProfile, CollaborateUserRef } from "../types/collaborateThread";

const PLAYBOOK_TAG_RE = /<playbook>@?([^<]*)<\/playbook>/i;

export function parsePlaybookNameFromBody(body: string): string | null {
  const m = body.match(PLAYBOOK_TAG_RE);
  if (!m) {
    return null;
  }
  const name = m[1].trim().replace(/^@/, "");
  return name || null;
}

export function hasPlaybookTag(body: string): boolean {
  return PLAYBOOK_TAG_RE.test(body);
}

/** Resolve the playbook reviewer from the editor node attrs (authoritative user id). */
export function parsePlaybookAssigneeFromEditor(
  editor: Editor,
  users: CollaborateUserProfile[],
): CollaborateUserRef | null {
  let assigneeId: string | null = null;
  let assigneeLabel: string | null = null;
  editor.state.doc.descendants((node) => {
    if (node.type.name !== "playbook") {
      return;
    }
    const id = String(node.attrs.id ?? "").trim();
    const label = String(node.attrs.label ?? "").trim();
    if (id) {
      assigneeId = id;
      assigneeLabel = label || null;
    }
  });
  if (!assigneeId) {
    return null;
  }
  const user = users.find((entry) => entry.id === assigneeId);
  if (user) {
    return { id: user.id, name: user.name, email: user.email };
  }
  return {
    id: assigneeId,
    name: assigneeLabel ?? assigneeId,
    email: "",
  };
}

/** Strip playbook tags so @-mention parsing does not treat assignee name as a mention. */
export function stripPlaybookTags(body: string): string {
  return body.replace(/<playbook>@?[^<]*<\/playbook>/gi, "");
}
